export const FAIL_STATUSES = new Set(['failed', 'rejected', 'undelivered', 'complained']);

/** Totals at or above this are shown as a floor rather than an exact count. */
export const SEARCH_COUNT_CAP = 10000;

export const RAW_STATUS_CONFIG: Record<string, { label: string; fg: string; bg: string }> = {
  failed: { label: 'Failed', fg: 'rgb(153,0,25)', bg: 'rgb(255,229,234)' },
  rejected: { label: 'Rejected', fg: 'rgb(153,0,25)', bg: 'rgb(255,229,234)' },
  undelivered: { label: 'Undelivered', fg: 'rgb(153,0,25)', bg: 'rgb(255,229,234)' },
  complained: { label: 'Complained', fg: 'rgb(153,0,25)', bg: 'rgb(255,229,234)' },
  delivered: { label: 'Delivered', fg: 'rgb(23,111,105)', bg: 'rgb(232,255,248)' },
  opened: { label: 'Opened', fg: 'rgb(23,111,105)', bg: 'rgb(232,255,248)' },
  clicked: { label: 'Clicked', fg: 'rgb(23,111,105)', bg: 'rgb(232,255,248)' },
  read: { label: 'Read', fg: 'rgb(23,111,105)', bg: 'rgb(232,255,248)' },
  sent: { label: 'Sent', fg: '#4951EF', bg: 'rgb(238,235,255)' },
  queued: { label: 'Queued', fg: '#4951EF', bg: 'rgb(238,235,255)' },
  sending: { label: 'Sending', fg: '#4951EF', bg: 'rgb(238,235,255)' },
  accepted: { label: 'Accepted', fg: '#4951EF', bg: 'rgb(238,235,255)' },
  scheduled: { label: 'Scheduled', fg: '#4951EF', bg: 'rgb(238,235,255)' },
  created: { label: 'Created', fg: '#767676', bg: '#F0F0F0' },
  preparing: { label: 'Preparing', fg: '#767676', bg: '#F0F0F0' },
  canceled: { label: 'Canceled', fg: '#767676', bg: '#F0F0F0' },
  unsubscribed: { label: 'Unsubscribed', fg: 'rgb(178,96,0)', bg: 'rgb(255,243,229)' },
};
